import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwitchCameraIcon(props: IconProps) {
    return <Icon {...props} iconKey={"switch_camera"}/>
}
